import React from 'react';
import {Route} from 'react-router';
import {Link, NavLink, Redirect} from 'react-router-dom';
import PropTypes from 'prop-types';
import Registry from 'registry';
import url from 'url';

import * as l10n from 'l10n';

export function localizeUrl(href) {
    let langPrefix = l10n.getLangPrefix(l10n.getLocale());

    let oUrl = url.parse(href);

    let re = new RegExp('^' + langPrefix, 'i');
    let newPathname = re.test(oUrl.pathname) ? oUrl.pathname : langPrefix + oUrl.pathname;

    let result = "";

    if(oUrl.host) {
        re = new RegExp('^' + Registry.get('BACKEND_URL'), 'i');
        let origin = oUrl.protocol + "//" + oUrl.host;
        result = re.test(origin) ? "" : origin;
    }

    result = result + newPathname + (oUrl.search ? oUrl.search : "") + (oUrl.hash ? oUrl.hash : "");

    return result;
}

export function getLocalizedRoomUrl(room) {
    return room.url_lc ? room.url_lc[l10n.getLocale()] : room.url;
}

function localizeTo(to) {
    return typeof to === "object" ?
        {...to, pathname: localizeUrl(to.pathname)} :
        localizeUrl(to);
}

function LocalizedRoute(props) {
    let {path, ...rest} = props;

    return <Route path={localizeUrl(path)} {...rest}/>;
}

function LocalizedLink(props) {
    let {to, href, children, ...rest} = props;
    if (to) {
        return <Link to={localizeTo(to)} {...rest}>{children}</Link>
    } else if (href) {
        return <a href={localizeUrl(href)} {...rest}>{children}</a>
    }
    return null;
}

function LocalizedNavLink(props) {
    let {to, children, ...rest} = props;

    if (to) {
        return <NavLink to={localizeTo(to)} {...rest}>{children}</NavLink>
    }
}

function LocalizedRedirect(props) {
    let {to, ...rest} = props;

    if (to) {
        return <Redirect to={localizeTo(to)} {...rest}/>
    }
}

/**
 * OrphanLink is used to render react-router's Link outside of the component tree by passing router in context
 */
class OrphanLocalizedLink extends React.Component {
    getChildContext() {
        // context required for react-router's Link
        return this.props.__context || this.context;
    }

    render() {
        let {children, __context, ...rest} = this.props;
        return <LocalizedLink {...rest}>{children}</LocalizedLink>
    }
}

OrphanLocalizedLink.propTypes = {
    __context: PropTypes.object
};

OrphanLocalizedLink.childContextTypes = {
    router: PropTypes.object
};

export {
    LocalizedRoute as LocalizedRoute,
    LocalizedLink as LocalizedLink,
    LocalizedNavLink as LocalizedNavLink,
    LocalizedRedirect as LocalizedRedirect,
    LocalizedRoute as Route,
    LocalizedLink as Link,
    LocalizedNavLink as NavLink,
    LocalizedRedirect as Redirect,
    OrphanLocalizedLink
};


// WEBPACK FOOTER //
// ./src/components/ReactRouterDomLocalized.js